/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable arrow-body-style */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable react/no-danger */

import React from 'react'
import Image from 'next/image'
import assetLoader from '@utils/internalImageLoader'
import { HTMLTagsForHowTo } from '@configs/howToHTMLTag'
import CheckBoxInputField from './checkBoxInputField'
import styles from './stepCards.module.scss'

const cardItem = ({ item, index, fieldsetsCount, isHowToComp }) => {
  const shouldAddMargin = fieldsetsCount > 1
  const { ItemTag } = HTMLTagsForHowTo.nStep(isHowToComp)

  const cheerio = typeof window === 'undefined' ? global.cheerio : window.cheerio

  const getModifiedHtml = tableContent => {
    const $ = cheerio.load(tableContent, null, false)

    $('p').each((_index, element) => {
      const $p = $(element)
      if ($p.html().trim() === '&nbsp;') {
        $p.remove()
      }
    })

    $('a').each((_index, element) => {
      const $a = $(element)
      $a.attr('target', '_blank')
    })

    const modifiedHTML = $.html()
    return modifiedHTML
  }

  return (
    <CheckBoxInputField item={item} index={index} type="withImage">
      <ItemTag className={`${styles.cardItem} ${shouldAddMargin ? styles.addMargin : styles.addHeight}`}>
        {item.stepIconText !== '' && item.stepIconText && (
          <div className={styles.cardStepIcon}>
            <Image
              src={`${assetLoader()}/images/step-card-img.svg`}
              alt="Image StepCard"
              width={23}
              height={23}
              loading="lazy"
            />
            <p>{item.stepIconText}</p>
          </div>
        )}
        <div className={styles.cardContent} dangerouslySetInnerHTML={{ __html: getModifiedHtml(item.stepCardInfo) }} />
      </ItemTag>
    </CheckBoxInputField>
  )
}

export default cardItem
